import { z } from 'zod';
/**
 * Réglages du cercle (US-12 « limite d'invités paramétrable », US-11 récurrence).
 * Le schéma est fermé : un réglage inconnu est refusé plutôt que stocké silencieusement.
 */
export const settingsSchema = z.object({
    /** Invités qu'un membre peut déclarer pour une séance. Défaut 2. */
    maxGuests: z.number().int().min(0).max(10),
    /** Expression de récurrence de la génération automatique de séance. */
    sessionRecurrence: z.enum(['first-tuesday', 'none']),
    /** Heure de début des séances générées, format HH:mm. */
    sessionStartTime: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
    /** Durée par défaut d'une séance, en minutes. */
    sessionDurationMinutes: z.number().int().min(15).max(600),
    sessionLocation: z.string().max(120),
});
export const DEFAULT_SETTINGS = {
    maxGuests: 2,
    sessionRecurrence: 'first-tuesday',
    sessionStartTime: '18:00',
    sessionDurationMinutes: 30,
    sessionLocation: 'Salle Courbet',
};
export const updateSettingsSchema = settingsSchema.partial();
//# sourceMappingURL=setting.js.map